module.exports = __webpack_public_path__ + "static/assets/ee3e4573644d7c8acf27898743e3fa1c.svg";